<table-container [noResultMessage]="'Good job! No issues were found' | translate"
                 [collection]="pages"
                 (onPageChange)="pageChange.emit($event)"
                 (onPerPageChange)="perPageChange($event)"
                 [progress]="progress"
                 class="pages-table-wrapper"
>
    <table-container-top>
        <div class="outer-b merge-r-36 merge-l-36 merge-t-10" *ngIf="isFiltersOpen">
            <table-filters [(open)]="isFiltersOpen"
                           (openChange)="isFiltersOpenChange.emit($event)"
                           [(ngModel)]="filters"
                           name="filters"
                           [filters]="availableFilters"
                           (onChanges)="onFiltersChanges.emit($event)">
            </table-filters>
        </div>
    </table-container-top>
    <table class="table table-hover table-fixed table-with-labels">
        <thead>
            <tr>
                <th monTableSort
                    class="col-25"
                    [monSortDirection]="currentSort.direction"
                    monSortBy="title"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onPageSort.emit($event)">
                    {{'Title and URL' | translate}}
                </th>
                <th class="col-8 text-right"
                    monTableSort
                    [monSortDirection]="currentSort.direction"
                    monSortBy="notification_count"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onPageSort.emit($event)">
                    {{'Notifications' | translate}}
                </th>
                <th *ngIf="tab !== 'pdf' && tab !== 'document' && target !== 'page-details-section-inventory'"
                    monTableSort
                    class="text-right pr-6 col-sm-4 col-md-4 col-lg-4"
                    [monSortDirection]="currentSort.direction"
                    monSortBy="priority_score"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onPageSort.emit($event)">
                    {{'Priority' | translate}}
                    <span class="ml-1"
                          data-test="tooltip-icon-severity"
                          [ngClass]="['PRIORITIZED', 'QUESTION_CIRCLE'] | monIcons"
                          aria-hidden="true"
                          ngbTooltip="{{ 'Calculated by no. and severity of issues, page views and links leading to this page..' | translate }}"
                          [triggers]="'focus hover'">
                    </span>
                </th>
                <th *ngIf="tab !== 'pdf' && tab !== 'document' && viewsColumIsAvailable"
                    class="table-header-page-views col-3 text-right"
                    monTableSort
                    [monSortDirection]="currentSort.direction"
                    monSortBy="hits"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onPageSort.emit($event)">
                    <span>{{ 'Views' | translate }}</span>
                    <span *ngIf="hasAccessToStats"
                          data-test="tooltip-30-days-views"
                          class="ml-1"
                          [ngClass]="['PRIORITIZED', 'QUESTION_CIRCLE'] | monIcons"
                          aria-hidden="true"
                          ngbTooltip="{{ 'Total page views over the last 30 days' | translate }}"
                          [triggers]="'focus hover'">
                    </span>
                    <span *ngIf="!hasAccessToStats"
                          class="ml-1"
                          [ngClass]="['PRIORITIZED', 'EXCLAMATION'] | monIcons"
                          aria-hidden="true"
                          ngbTooltip="{{ 'Statistics not activated. Page Views not available.' | translate }}"
                          [triggers]="'focus hover'">
                    </span>
                </th>
                <th class="col-sm-8 col-lg-6">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let page of pages">
                <td>
                    <div class="text-ellipsis">
                        <url-title
                                *ngIf="!pageDetailsIsAvailable"
                                [title]="page.title"
                                [url]="page.url"
                                [active]="false">
                        </url-title>
                        <url-title-page-details
                                *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                [target]="target"
                                [subTarget]="subTarget"
                                [page]="page"
                                [title]="pageTitle(page.title)"
                                [url]="page.url"
                                (onClose)="callBack.emit()"
                                [active]="true">
                        </url-title-page-details>

                        <url-title-document-details [document]="page"
                                                    *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                    [title]="pageTitle(page.title)"
                                                    [url]="page.url"
                                                    [target]="target"
                                                    [active]="true"
                                                    [subTarget]="subTarget">
                        </url-title-document-details>
                    </div>
                    <label-table *ngIf="showLabels"
                                     [assignedLabels]="page.labels"
                                     [existingLabels]="labels"
                                     (getLabels)="getLabels()"
                                     (onUpdateLabel)="updateLabels(page)">
                    </label-table>
                </td>
                <td class="text-v-middle text-right">
                    <notification-dropdown [showCategories]="showNotifications" [page]="page"></notification-dropdown>
                </td>
                <td *ngIf="tab !== 'pdf' && tab !== 'document' && target !== 'page-details-section-inventory'" class="text-v-middle text-right pr-6">
                    <mon-priority class="vcenter" [priority]="page.priority_score_as_text">
                    </mon-priority>
                </td>
                <td class="pl-5 text-v-middle" *ngIf="tab !== 'pdf' && tab !== 'document' && viewsColumIsAvailable">
                    <visits *ngIf="viewsColumIsAvailable"
                        [visits]="page.hits"
                        [title]="page.title"
                        [totalVisits]="pages.pageHits">
                    </visits>
                </td>
                <td class="text-v-middle">
                    <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                        <table-page-details
                                *ngIf="page.type === 'html'"
                                ngbTooltip="{{'Open page details' | translate}}"
                                [triggers]="'focus hover'"
                                [target]="target"
                                [subTarget]="subTarget"
                                [page]="page"
                                [ref]="ref"
                                (callBack)="callBack.emit()">
                        </table-page-details>
                        <table-document-details
                                *ngIf="page.type !== 'html'"
                                ngbTooltip="{{'Open document details' | translate}}"
                                [triggers]="'focus hover'"
                                [target]="target"
                                [subTarget]="subTarget"
                                [document]="page"
                                (callBack)="callBack.emit()">
                        </table-document-details>
                        <extension-visual-link-button [page]="page" [type]="issueType" class="ml-1"></extension-visual-link-button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</table-container>
